<header class="header">

  <div id="mid-layer">
    <div class="mid-layer-container">
      <div class="logo-musei-italiani">
        @if(!isGroupPaymentPage){
          <button class="btn-home d-md-none" (click)="checkStepAndRedirect('HOME')"
            [attr.aria-label]="'Header.HOME_BTN_ALT_TEXT' | translate"
            [tabIndex]="isElementNavigable ? 0 : -1">
            <img loading="eager" id="logo-mi-mini" class="d-md-none img-fluid"
              [src]="assetsContextRoot + 'assets/images/logo-mi-mini.webp'"
              alt="{{'Header.LOGO_ALT_TEXT' | translate}}" width="150px" height="28px">
          </button>
          <a href="https://www.museiitaliani.it" target="_blank">
            <img loading="eager" id="logo-musei-ita" class="d-none d-md-inline"
              [src]="assetsContextRoot + 'assets/images/logo-musei-italiani-header.webp'"
              alt="{{'Header.LOGO_ALT_TEXT' | translate}}" width="85px" height="47px">
          </a>
          <span class="d-none d-md-inline text-title-header">{{ 'Header.BUY_TICKET' | translate }}</span>
        } @else {
          <a href="https://www.museiitaliani.it" target="_blank">
            <img loading="eager" id="logo-musei-ita-business" class="d-inline"
              [src]="assetsContextRoot + 'assets/images/musei_italiani_business.webp'"
              alt="{{'Header.LOGO_ALT_TEXT' | translate}}" width="85px" height="47px">
          </a>
        }
      </div>

      <nav class="info-links">

        @if(!isGroupPaymentPage){

          <button class="reset-btn-style d-flex"
          (click)="toggleSidebar()"
          [attr.aria-label]="'Header.SIDEBAR_BTN_ALT_TEXT' | translate"
          [tabIndex]="isElementNavigable ? 0 : -1">
            <span class="info-links-item material-symbols-sharp nav-icon">
              account_circle
            </span>
          </button>
        }

        <button class="reset-btn-style info-links-item lang-switch justify-content-end justify-content-md-center"
          (click)="openLanguageSelectModal()"
          [attr.aria-label]="'Header.LANG_SWITCH_BTN_ALT_TEXT' | translate"
          [attr.aria-expanded]="isLangDropDownOpen"
          [tabIndex]="isSideBarOpen ? -1 : 0">
          <span class="lang-switch-btn">{{ getLangRegionLabel()}}</span>
          <span *ngIf="!isLangDropDownOpen" aria-hidden="true" class="material-symbols-sharp nav-icon">
            expand_more
          </span>
          <span *ngIf="isLangDropDownOpen" aria-hidden="true" class="material-symbols-sharp nav-icon">
            expand_less
          </span>
        </button>
      </nav>
    </div>
  </div>

  <nav id="b2c-navbar" class="bg-light">

    <!-- ! SIDEBAR -->
    <div id="burger-menu">
      <div id="side-menu" #sideMenu>
        <div class="side-menu-header">
          <h2>{{"Header.TITOLO_AREA" | translate}}</h2>
        </div>

        <div class="side-menu-body">

          <div class="side-menu-welcome">
            <span>{{"Header.SIDEBAR_WELCOME" | translate}} {{anagraficaUtente?.nom}}</span>
          </div>

          <ul class="side-menu-item-list">

            @if(isUserLogged && !!isUserSubscribedToCurrentCampaign()){
              <div class="rewards-point-recap-container">
                <div class="rewards-point-recap-banner">
                  <span class="points-lable">{{ 'Rewards.POINTS_BALANCE' | translate | uppercase }}</span>

                  @if(!userPointsError()){
                    <span
                      class="points-counter"
                      [class]="{
                        'shimmer': isLoadingUserPoints()
                      }"
                    >
                      {{ campaignStatus() === CAMPAIGN_STATUS.ENDED ? 0 : userPointsBalance | async }} PT
                    </span>
                  } @else {
                    <span
                      class="points-counter"
                    >
                      {{ 'Rewards.ERROR' | translate }}
                    </span>
                  }

                  <div class="texts-container">
                    <div class="validity-dates">
                      <span aria-hidden="true" class="material-symbols-sharp icon">
                        calendar_month
                      </span>
                      @if(!campaignInfoLoadError()){
                        <div class="text-container" [class]="{ 'shimmer': isLoadingCampaingInfo() }">
                          @if(activeCampaign$ | async; as activeCampaign){
                            @if(campaignStatus() !== CAMPAIGN_STATUS.ENDED){
                              <span class="banner-text">
                                {{ 'Rewards.POINTS_VALIDITY_DATES' | translate:{ from: activeCampaign.campaignStarts | date:'dd/MM/yyyy', to: activeCampaign.campaignEnds | date:'dd/MM/yyyy' } }}
                              </span>
                            } @else {
                              <span class="banner-text">
                                {{ 'Rewards.EXPIRED_ON' | translate:{ date: activeCampaign.campaignEnds | date:'dd/MM/yyyy' } }}
                              </span>
                            }
                          }
                        </div>
                      } @else {
                        <span class="banner-text">{{ 'Rewards.LOAD_ERROR' | translate }}</span>
                      }
                    </div>
                    <div class="active-vouchers-counter">
                      <span aria-hidden="true" class="material-symbols-sharp icon">
                        featured_seasonal_and_gifts
                      </span>

                      @if(!userActiveVouchersLoadError()){
                        <div class="text-container" [class]="{ 'shimmer': isLoadingUserActiveVouchers() }">
                          @if(userActiveVouchers$ | async; as activeVouchers){
                            <span class="banner-text">{{ 'Rewards.ACTIVE_VOUCHERS' | translate }}: {{ activeVouchers.count }}</span>
                          }
                        </div>
                      } @else {
                        <span class="banner-text">{{ 'Rewards.LOAD_ERROR' | translate }}</span>
                      }
                    </div>
                  </div>

                  <button class="go-to-wallet-btn" (click)="checkStepAndRedirect('WALLET')">{{ 'Rewards.GO_TO_VALLET' | translate }}</button>
                </div>
              </div>
            } @else if (!isUserSubscribedToCurrentCampaign()  && isUserLogged && campaignStatus() !== CAMPAIGN_STATUS.ENDED){
              <div class="rewards-point-recap-container">
                <active-campaign-banner [campaingInfo]="fullActiveCampaingInfo$ | async" (linkClicked)="toggleSidebar()"></active-campaign-banner>
              </div>
            }

            <legend>{{"Header.SETTINGS" | translate}}</legend>

            <li>
              <button class="w-100 reset-btn-style side-menu-item mt-4"
                (click)="checkStepAndRedirect('HOME')"
                [tabIndex]="isSideBarOpen ? 0 : -1"
                [attr.aria-label]="'Header.HOME' | translate"
              >
                <div>
                  <span aria-hidden="true" class="material-symbols-sharp">
                    home
                  </span>
                  <span>{{ "Header.HOME" | translate}}</span>
                </div>
                <span aria-hidden="true" class="material-symbols-sharp rtl-icon">
                  chevron_right
                </span>
              </button>
            </li>

            <li>
              <button class="w-100 reset-btn-style side-menu-item mt-4"
                (click)="checkStepAndRedirect('MY_PROFILE')"
                [tabIndex]="isSideBarOpen ? 0 : -1"
                [attr.aria-label]="'Header.MY_PROFILE' | translate"
              >
                <div>
                  <span aria-hidden="true" class="material-symbols-sharp">
                    account_circle
                  </span>
                  <span>{{"Header.MY_PROFILE" | translate}}</span>
                </div>
                <span aria-hidden="true" class="material-symbols-sharp rtl-icon">
                  chevron_right
                </span>
              </button>
            </li>

            <li>
              <button class="w-100 reset-btn-style side-menu-item"
                (click)="checkStepAndRedirect('MY_TICKETS')"
                [tabIndex]="isSideBarOpen ? 0 : -1"
                [attr.aria-label]="'Header.MY_TICKETS' | translate"
              >
                <div>
                  <span aria-hidden="true" class="material-symbols-sharp">
                    confirmation_number
                  </span>
                  <span>{{"Header.MY_TICKETS" | translate}}</span>
                </div>
                <span aria-hidden="true" class="material-symbols-sharp rtl-icon">
                  chevron_right
                </span>
              </button>
            </li>

            <li>
              <button class="w-100 reset-btn-style side-menu-item"
                (click)="checkStepAndRedirect('CONTACTS')"
                [tabIndex]="isSideBarOpen ? 0 : -1"
                [attr.aria-label]="'Header.CONTACTS' | translate"
              >
                <div>
                  <span aria-hidden="true" class="material-symbols-sharp">
                    import_contacts
                  </span>
                  <span>{{"Header.CONTACTS" | translate}}</span>
                </div>
                <span aria-hidden="true" class="material-symbols-sharp rtl-icon">
                  chevron_right
                </span>
              </button>
            </li>

            <!-- WIP -->
            <button class="w-100 reset-btn-style side-menu-item d-none"
              [tabIndex]="isSideBarOpen ? 0 : -1">
              <div>
                <span aria-hidden="true" class="material-symbols-sharp">
                  search
                </span>
                <span>{{"Header.BUY_TICKETS" | translate}}</span>
              </div>
              <span aria-hidden="true" class="material-symbols-sharp rtl-icon">
                chevron_right
              </span>
            </button>
          </ul>

          <div class="side-menu-footer">
            <div class="footer-content">

              @if(isUserLogged){
                <div class="logged-user-section">
                  <button class="reset-btn-style side-menu-item logout-sidebar"
                    (click)="logout()"
                    [tabIndex]="isSideBarOpen ? 0 : -1">
                    <span>{{"Header.LOGOUT" | translate}}</span>
                  </button>
                </div>
              } @else {
                <div class="non-logged-user-section">

                  <span class="footer-title">{{"Header.AUTHENTICATION_REQUIRED" | translate}}</span>
                  <span class="footer-message">{{"Header.NON_AUTHENTICATED_MSG" | translate}}</span>

                  <button (click)="login()" [tabIndex]="isSideBarOpen ? 0 : -1">{{"Header.LOG_IN_SIGN_IN" | translate}}</button>

                </div>
              }

            </div>
          </div>

        </div>

      </div>
      <div id="overlay" [ngClass]="{'d-none': !isSideBarOpen}" (click)="toggleSidebar()"></div>
    </div>

  </nav>

</header>

<div id="lang-drop-overlay" [ngClass]="{'d-none': !isLangDropDownOpen}" (click)="toggleLangDropDown()"></div>

<simple-confirm-dialog #confirmRedirect
  [title]="'Header.CONFIRM_REDIRECT_MODAL_TITLE' | translate"
  [description]="'Header.CONFIRM_REDIRECT_MODAL_TXT' | translate"
  [btnConfirm]="'Header.CONFIRM_REDIRECT_MODAL_CONFIRM' | translate"
  [btnClose]="'Header.CONFIRM_REDIRECT_MODAL_CANCEL' | translate"
  (close)="closeDialog()"
  (confirm)="redirectForModal()"
>
</simple-confirm-dialog>

<simple-confirm-dialog #confirmDeleteAccount
  [title]="'Header.CONFIRM_DELETE_ACCOUNT_TITLE' | translate"
  [description]="'Header.CONFIRM_DELETE_ACCOUNT_DESC' | translate"
  (confirm)="deleteUserAccount()"
></simple-confirm-dialog>

<simple-confirm-dialog #accountDeletedSuccess
  [title]="'Header.ACCOUNT_DELETED_SUCCES_DIALOG_TITLE' | translate"
  [description]="'Header.ACCOUNT_DELETED_SUCCES_DIALOG_DESC' | translate"
  (confirm)="logout()"
  [hideCloseIcon]="true"
  [hideCloseButton]="true">
</simple-confirm-dialog>

<simple-error-dialog #accountDeletedError
  [title]="'Header.ACCOUNT_DELETED_ERROR_DIALOG_TITLE' | translate"
  [description]="'Header.ACCOUNT_DELETED_ERROR_DIALOG_DESC' | translate"
>
</simple-error-dialog>

<simple-error-dialog #loginErrorDialog
  [title]="'Header.LOGIN_ERROR_DIALOG_TITLE' | translate"
  [description]="'Header.LOGIN_ERROR_DIALOG_TEXT' | translate"
  (confirm)="logout()"
  (close)="logout()"
>
</simple-error-dialog>

<language-select-dialog #languageSelectDialog></language-select-dialog>
